import React from 'react';
import BaseIcon from './BaseIcon';

interface ChevronLeftIconProps {
  className?: string;
}

const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({ className = "w-5 h-5" }) => (
  <BaseIcon className={className} strokeWidth={2}>
    <path d="m15 18-6-6 6-6"></path>
  </BaseIcon>
);

export default ChevronLeftIcon;
